import { AtMentionsViewState } from '../store/schema/AtMentionsViewState';

export default function createAtMentionsViewState(
    pendingSocialActivityTags: string[]
): AtMentionsViewState {
    const viewState = <AtMentionsViewState>{
        queryString: '',
        wordBeforeCursor: '',
        isSuggesting: false,
        isPopupShown: false,
        recipientsShown: [],
        selectedRecipientIndex: 0,
        isSearching: false,
        hasSearchedDirectory: false,
        atMentionTuples: {},
        mentionsAddedRecipients: [],
    };
    if (pendingSocialActivityTags && pendingSocialActivityTags.length > 0) {
        pendingSocialActivityTags.forEach(tag => {
            const parsedObj = JSON.parse(tag);
            if (parsedObj && parsedObj.a && parsedObj.b) {
                const parsedTagContents = JSON.parse(parsedObj.a);
                if (parsedTagContents) {
                    if (
                        parsedObj.b == 'MentionAddedRecipients' &&
                        parsedTagContents instanceof Array
                    ) {
                        viewState.mentionsAddedRecipients = parsedTagContents as string[];
                    } else if (parsedTagContents.Mentioned) {
                        viewState.atMentionTuples[parsedObj.b] = {
                            EmailAddress: parsedTagContents.Mentioned,
                        };
                    }
                }
            }
        });
    }
    return viewState;
}
